// Services
import { ContractConsentViewType } from '../../contractual/hooks/types/contract.view.hook.types';
import { getScreenDetailsService, saveScreenService } from '../services/pre-contract.view.services';
// Types
import { PreContractViewDataApiResponseType } from '../types/pre-contract-view-data-api-response.type';
// Utils
import { requestHasSuccessStatus } from '@openbank/cf-ui-framework';

const loadScreenDetailsResolver = async (): Promise<
  [PreContractViewDataApiResponseType] | [null, boolean]
> => {
  const [response, { status }] = await getScreenDetailsService();

  return requestHasSuccessStatus(status) ? [response] : [null, true];
};

const saveScreenResolver = async (
  consents: ContractConsentViewType[]
): Promise<[null] | [null, boolean]> => {
  const [response, { status }] = await saveScreenService(consents);

  return requestHasSuccessStatus(status) ? [response] : [null, true];
};

export { loadScreenDetailsResolver, saveScreenResolver };
